import React from 'react'
import 'tw-elements';



const Carrusel = ({news, files}) => {
    return (
        <div id="carouselExampleCaptions" className="carousel slide relative w-full" data-bs-ride="carousel">
            <div className="carousel-indicators absolute right-0 bottom-0 left-0 flex justify-center p-0 mb-4">
                <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                ></button>
                <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                ></button>
            </div>
            <div className="carousel-inner relative w-full overflow-hidden rounded-xl">
                <div className="carousel-item active relative float-left w-full">
                    <div className='bg-index-background bg-cover bg-center 2sm:px-10 px-4 h-[300px] 2sm:h-screen'>
                        <div className='flex flex-col items-center bg-black py-4 2sm:w-[400px] w-[80%] 2sm:p-6 p-2 rounded-xl bg-opacity-70 shadow-xl animate__animated animate__fadeInUp absolute bottom-48 left-5'>
                            <h1 className='text-center font-mono font-bold w-full  text-white  lg:text-2xl md:text-xl text-sm '>DIRECCIÓN DE GESTIÓN CATASTRAL MULTIPROPÓSITO</h1>
                            <div className='bg-green-500 h-[3px] w-[90px] my-4'></div>
                        </div>
                    </div>
                </div>
                {news?.[0] && (
                <div className="carousel-item relative float-left w-full">
                    <div className='bg-cover bg-center px-4 h-[300px] 2sm:h-screen' style={{backgroundImage: `url('data:image/png;base64,${files[0]}')`}}>
                        <div className='flex flex-col items-center bg-black py-4 2sm:w-[400px] w-[80%] 2sm:p-6 p-2 rounded-xl bg-opacity-70 shadow-xl animate__animated animate__fadeInUp absolute bottom-48 left-5'>
                            <h1 className='text-center font-mono font-bold w-full text-white lg:text-2xl md:text-xl text-sm'>{news[0].newTitle}</h1>
                            <div className='bg-green-500 h-[3px] w-[90px] my-4'></div>
                        </div>
                    </div>
                </div>)}
                {(news?.[1]) && (
                <div className="carousel-item relative float-left w-full">
                    <div className='bg-cover bg-center px-4 h-[300px] 2sm:h-screen' style={{backgroundImage: `url('data:image/png;base64,${files[1]}')`}}>
                        <div className='flex flex-col items-center bg-black py-4 2sm:w-[400px] w-[80%] 2sm:p-6 p-2 rounded-xl bg-opacity-70 shadow-xl animate__animated animate__fadeInUp absolute bottom-48 left-5'>
                            <h1 className='text-center font-mono font-bold w-full  text-white  lg:text-2xl md:text-xl text-sm '>{news[1].newTitle}</h1>
                            <div className='bg-green-500 h-[3px] w-[90px] my-4'></div>
                        </div>
                    </div>
                </div>
                )}
            </div>
            <button
                className="carousel-control-prev absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline left-0"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="prev"
            >
                <span className="carousel-control-prev-icon inline-block bg-no-repeat" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button
                className="carousel-control-next absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline right-0"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="next"
            >
                <span className="carousel-control-next-icon inline-block bg-no-repeat" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    );
}

export default Carrusel;